import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HomePage } from './pages/Home';
import { LoginPage } from './pages/Login';
import { Navbar } from './components/layout/Navbar';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      {location.pathname !== "/login" && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center">
              <h2 className="text-2xl font-bold text-slate-800">404 - Página não encontrada</h2>
            </div>
          } />
        </Routes>
      </main>
    </>
  );
}

export default App;